import { Grid } from '@mui/material';
import { useCompanyRelativePath } from 'ogp/hooks';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header, LwBlockGridContainer, LwButton, Page, Toolbox, useOnScrollDown } from 'redesign';
import { routes } from 'Routes';
import { IconAdd } from 'assets/img';
import { EmployeeCard } from './components/employee-card/employee-card';
import { useGetWorkforce } from './hooks/use-get-workforce';

const Workforce = () => {
  const workforceQuery = useGetWorkforce();
  const navigate = useNavigate();
  const generatePath = useCompanyRelativePath();

  const { data } = workforceQuery;
  const flatData = useMemo(() => data?.pages.flatMap((page) => page.items) ?? [], [data]);
  const { fetchIfBottomScrolled } = useOnScrollDown({
    infiniteQueryResult: workforceQuery,
    flatData,
  });

  return (
    <Page
      header={<Header titleText="Personeelsbestand" />}
      toolbox={
        <Toolbox>
          <LwButton
            to={generatePath(routes.EmployeeCreate)}
            startIcon={<IconAdd />}
            color="primary"
            iconColorMode="fill"
          >
            Voeg werknemer toe
          </LwButton>
        </Toolbox>
      }
      onContentScroll={(e) => {
        fetchIfBottomScrolled(e.target as HTMLDivElement);
      }}
    >
      <LwBlockGridContainer container spacing={4}>
        <Grid container spacing={4}>
          {flatData?.map((employee) => (
            <Grid key={employee.id} item xs={6} md={4} lg={3}>
              <EmployeeCard
                key={employee.id}
                {...employee}
                onClick={() => {
                  navigate(
                    generatePath(routes.EmployeeDetail, {
                      id: employee.id,
                    })
                  );
                }}
              />
            </Grid>
          ))}
        </Grid>
      </LwBlockGridContainer>
    </Page>
  );
};

export { Workforce };
